import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import SnmpDestCreate from './containers/SnmpDestCreate';
import SnmpDestEdit from './containers/SnmpDestEdit';
import SnmpDestList from './containers/SnmpDestList';
import SnmpDestView from './containers/SnmpDestView';
import {
  SYSTEM_CONFIGURATION_ROUTE,
  SNMP_DEST,
  NETWORK
} from '../../constants';

interface Props {}

const SnmpDestination: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route
        exact
        path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${SNMP_DEST}`}
      >
        <SnmpDestList />
      </Route>
      <Route
        exact
        path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${SNMP_DEST}/create`}
      >
        <SnmpDestCreate />
      </Route>
      <Route
        exact
        path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${SNMP_DEST}/edit`}
      >
        <SnmpDestEdit />
      </Route>
      <Route
        exact
        path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${SNMP_DEST}/view`}
      >
        <SnmpDestView />
      </Route>
    </Fragment>
  );
};

export default SnmpDestination;
